import React from 'react';
import Card from '@teetsh/app/src/components/Card';
import _orderBy from '@teetsh/app/src/utils/arrays/orderBy';
import { AbsencesList } from './AbsencesList';
import { EleveAbsences } from '@teetsh/app/src/queries/appels/useAppelsAbsences';
import { useTranslation } from 'react-i18next';

interface Props {
  eleve?: EleveAbsences;
  print?: boolean;
}

export function ElevesAbsencesList(props: Props) {
  const { eleve, print } = props;
  const { t } = useTranslation(['registreAppel']);
  return (
    <Card
      print={print}
      title={t('registreAppel:listAbsencesOf', {
        name: eleve?.givenName || '???',
      })}
    >
      {eleve ? (
        <AbsencesList
          print={print}
          absences={_orderBy(eleve.absences, ['date'], ['asc'])}
        />
      ) : (
        <p>{t('registreAppel:xAbsence', { count: 0 })}</p>
      )}
    </Card>
  );
}
